module.exports = __webpack_public_path__ + "static/media/29EUNOG1.19d84d24.jpg";